import React from 'react'
import { createPortal } from 'react-dom'
import MuiButton from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery'
import AddIcon from '@mui/icons-material/Add'
import { styled } from '@mui/material/styles'

import { MOBILE_QUERY, useMobileShell } from '../layout/mobile-shell'

const StyledButton = styled(MuiButton)(({ btnstyle }) => {
  let background = '#2563EB'
  let color = '#FFFFFF'
  let hoverBg = '#2563EB'
  let outlinedBg = '#fff'
  let outlinedColor = '#4A545E'
  let outlinedBorder = '#CFD6DD'
  let boxShadow = undefined
  let padding = undefined
  let borderRadius = '8px'

  if (btnstyle === 'login') {
    background = '#2563EB'
    color = '#FFFFFF'
    hoverBg = '#1D4ED8'
  } else if (btnstyle === 'alt') {
    background = '#E8F0FF'
    color = '#1D4ED8'
    hoverBg = '#E8F0FF'
  } else if (btnstyle === 'transparent') {
    background = 'transparent'
    color = '#E8F0FF'
    hoverBg = 'transparent'
    outlinedBg = 'transparent'
    boxShadow = 'none'
  } else if (btnstyle === 'iconPrimary') {
    background = '#2563EB'
    borderRadius = '10px'
    color = '#FFFFFF'
    hoverBg = '#1D4ED8'
    outlinedBg = '#2563EB'
    outlinedColor = '#FFFFFF'
    boxShadow = 'none'
    padding = '11px 16px'
  }

  return {
    height: btnstyle === 'login' ? 48 : btnstyle === 'iconPrimary' ? 40 : 36,
    textTransform: 'initial',
    fontSize: btnstyle === 'login' ? 18 : 14,
    fontWeight: btnstyle === 'login' ? 600 : 500,
    lineHeight: btnstyle === 'login' ? '24px' : '20px',
    padding: '8px 16px',
    background,
    color,
    boxShadow,
    borderRadius,
    ...(padding ? { padding } : {}),

    '&:hover': {
      background: hoverBg,
      color,
      boxShadow: boxShadow ?? undefined
    },

    '&:focus, &.Mui-focusVisible': {
      boxShadow: boxShadow ?? undefined
    },

    '&.MuiButton-sizeSmall': {
      height: btnstyle === 'iconPrimary' ? 'auto' : 28,
      ...(btnstyle === 'iconPrimary' ? {} : { padding: '4px 12px', fontSize: 13 }),
    },

    '&.MuiButton-outlined': {
      borderColor: outlinedBorder,
      color: outlinedColor,
      background: outlinedBg,
      boxShadow: boxShadow ?? undefined
    },

    '&.MuiButton-contained': {
      boxShadow: boxShadow ?? undefined
    },

    '& .MuiButton-startIcon': {
      marginRight: 8,
      marginLeft: 0,
    },
  }
})

// Главная кнопка страницы на телефоне - маленькая квадратная кнопка в верхней
// панели. Подпись «Добавить тариф» туда не помещается и крадёт место у
// названия раздела; подпись остаётся для скринридера
const MobileActionButton = styled('button')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: #2563EB;
  color: #FFFFFF;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:active {
    background: #1D4ED8;
  }

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }

  & svg {
    width: 20px;
    height: 20px;
  }
`

const textOf = (node) => {
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(textOf).join('')
  return ''
}

// pageAction - главная кнопка страницы (создать, добавить, пригласить). На
// телефоне переезжает в верхнюю панель иконкой; на компьютере остаётся как есть
const Button = ({ btnstyle = 'default', pageAction = false, ...props }) => {
  const { actionSlot } = useMobileShell()
  const isMobile = useMediaQuery(MOBILE_QUERY)

  if (pageAction && isMobile && actionSlot) {
    // Страницы прячут кнопку классом isHidden, когда она не к месту
    if (String(props.className || '').includes('isHidden')) return null
    const label = textOf(props.children)
    return createPortal(
      <MobileActionButton
        type="button"
        aria-label={label || 'Добавить'}
        title={label || undefined}
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {props.startIcon || <AddIcon />}
      </MobileActionButton>,
      actionSlot,
    )
  }

  return <StyledButton btnstyle={btnstyle} {...props} />
}

export default Button
